import React from 'react';
import './footer.css';
import { FaPhone, FaEnvelope, FaYoutube, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import footerContent from '../../content/pages/footer.json';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-section quick-links">
        <h3>Länkar</h3>
        <nav aria-label="Sidfotslänkar">
          <ul>
            <li><Link to="/produkter/balpressar">Balpressar</Link></li>
            <li><Link to="/produkter/komprimatorer">Komprimatorer</Link></li>
            <li><Link to="/about">Företag</Link></li>
            <li><Link to="/nyheter">Nyheter</Link></li>
            <li><Link to="/vanliga-fragor">Vanliga frågor</Link></li>
            <li><Link to="/kontakt">Kontakt</Link></li>
          </ul>
        </nav>
      </div>
      <div className="footer-section footer-contact-info">
        <h3>Kontakta oss</h3>
        <p><FaPhone /> {footerContent.phone}</p>
        <p><FaEnvelope /> {footerContent.email}</p>
        <div className="social-media">
          <a href={footerContent.youtubeUrl} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
          <a href={footerContent.linkedinUrl} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
